<template>
  <div>
    <CRow>
      <CCol sm="12" md="12" lg="3" xl="2">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Tickets Cancelados</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12" md="6" lg="12" xl="12">
                <CSelect
                  v-if="rol_id == 4"
                  label="Sede: "
                  :value.sync="selectedCampus"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="onCampusChange"
                />
              </CCol>
              <CCol sm="12" md="6" lg="12" xl="12">
                <CInput
                  label="Desde"
                  type="date"
                  aria-label="shift_date"
                  size="sm"
                  id="init"
                  v-model="filter.init"
                  @change="onCampusChange"
                  :max="hoy"
                />
              </CCol>
              <CCol sm="12" md="6" lg="12" xl="12">
                <CInput
                  label="Hasta"
                  type="date"
                  aria-label="shift_date"
                  id="end"
                  size="sm"
                  v-model="filter.end"
                  @change="onCampusChange"
                  :max="hoy"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12" md="12" lg="9" xl="10">
        <CRow>
          <CCol>
            <CTableWrapper
              hover
              :striped="true"
              :border="true"
              fixed
              caption="Lista de tickets cancelados"
              icon="fas fa-coins"
              :size="'md'"
              :actions="true"
              :withActions="'3%'"
              :fields="fields"
              :items="data_cancel"
              @mtdBack="mtdBack"
              btn_name="Cancelación"
              :button_new="true"
              @show_modal="mtd_open_modal"
              class="text-center"
              :myButtons="myButtons"
              @mtd_ticket="mtd_ticket"
              @mtd_cancel_ticket="mtd_cancel_ticket"
            />
          </CCol>
        </CRow>
        <CModalForm
          :backdrop="true"
          :closeOnBackdrop="true"
          :size="'lg'"
          :title="modal.title"
          :show.sync="modal.modal_form"
          :color="'info'"
          :centered="true"
          @mtd_action="mtd_action_vali"
        >
          <CRow>
            <CCol md="12">
              <label for="search">Buscar Documento: </label>
            </CCol>
            <CCol sm="2" md="2" lg="2" xl="2" class="col-2 pr-1">
              <CInput v-model="voucherSearch.correlative_serie" />
            </CCol>
            <CCol sm="7" md="8" lg="8" xl="8" class="col-7 px-1">
              <CInput
                placeholder="Ej: 01"
                v-model="voucherSearch.number"
                v-on:keypress="isNumber($event)"
                @keypress.enter="searchVocuher"
              />
            </CCol>
            <CCol sm="3" md="2" lg="2" xl="2" class="col-3 pl-1">
              <CButton
                class="w-100"
                color="info"
                v-c-tooltip.hover="{ content: `Buscar documento` }"
                @click="searchVocuher"
              >
                <i class="fas fa-search"></i>
              </CButton>
            </CCol>
            <CCol md="6">
              <CInput
                label="Cliente:"
                disabled
                v-model="voucherClient.client"
                placeholder="Busque un Doc."
              />
            </CCol>
            <CCol md="6">
              <CInput
                label="Monto:"
                disabled
                v-model="voucherCancel.amount"
                placeholder="Busque un Doc."
              />
            </CCol>
            <CCol md="12">
              <label for="search">Metodo: </label>
            </CCol>
            <CCol
              v-for="(item, index) in data_methodpayment"
              :key="index"
              sm="12"
              md="6"
              lg="6"
              xl="6"
              class="mb-2"
            >
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input
                      type="radio"
                      v-model="voucherCancel.method"
                      :value="item.id"
                      :aria-label="item.name"
                    />
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  :value="item.name"
                  disabled
                />
              </div>
            </CCol>
            <CCol>
              <CTextarea
                label="Motivo o descripción de cancelación"
                placeholder="Ingrese el motivo..."
                rows="3"
                class="mt-1"
                v-model="voucherCancel.motive"
              />
            </CCol>
          </CRow>
        </CModalForm>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "ID", _style: "width:1%" },
  { key: "personal_name", label: "Personal", _style: "width:12%" },
  { key: "campu", label: "Sede", _style: "width:12%;" },
  { key: "serie", label: "Serie y número de ticket", _style: "width:12%;" },
  { key: "date_format", label: "Fecha", _style: "width:12%;" },
  { key: "hour", label: "Hora", _style: "width:12%;" },
  { key: "client_name", label: "Cliente", _style: "width:12%;" },
  { key: "subtotal", label: "Subtotal", _style: "width:12%;" },
  { key: "total", label: "total", _style: "width:12%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../../shared/datatable/Table.vue";
import CModalForm from "../../../shared/modals/cModalForm.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,
    CModalForm,
  },
  data() {
    return {
      prefix: "cancelVoucher",
      rol_id: this.$store.getters.get_rol.id,
      hoy: null,
      data_campus: [],
      data_vouchers: [],
      selectedCampus: null,
      fields,
      content_voucher: [],
      data_cancel: [],
      filter: {
        init: null,
        end: null,
      },
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      voucherSearch: {
        campu_id: this.$store.getters.get_campu.id,
        correlative_serie: "",
        number: "",
      },
      voucherClient: {
        client: "",
        dni: "",
        amount: "",
      },
      voucherCancel: {
        voucher_id: 0,
        user_id: this.$store.getters.get__user_id,
        date: "",
        motive: "",
        state: 0,
        amount: null,
        method: null,
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
      },
      myButtons: [
        {
          class: "btn-sm d-flex mb-2",
          color: "dark",
          tooltip: "Ticket",
          action: "mtd_ticket",
          icon: "fas fa-file-pdf",
        },
        {
          class: "btn-sm ",
          color: "primary",
          tooltip: "Anular",
          action: "mtd_cancel_ticket",
          icon: "fas fa-solid fa-ban",
          show: {
            value: "is_state",
          },
        },
      ],
      data_methodpayment: [],
    };
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.hoy = moment().format("YYYY-MM-DD");

    this.selectedCampus = this.$store.getters.get_campu.id;

    this.getCampus();
    this.getCorrelatice();
    this.mtdGetMethods();
    this.setDefaultCampus();
  },
  computed: {
    isDisabled() {
      return (
        !this.voucherClient.client ||
        !this.voucherCancel.amount ||
        !this.voucherClient.method ||
        !this.voucherCancel.motive
      );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("returnHome");
    },
    setDefaultCampus() {
      this.selectedCampus = this.$store.getters.get_campu.id;
      this.getData(this.selectedCampus);
    },
    onCampusChange() {
      if (this.selectedCampus == null) {
        this.getData();
      } else {
        this.getData(this.selectedCampus);
      }
    },
    closeModal() {
      this.modal = {
        action: "",
        title: "",
        modal_form: false,
      };
      //this.data_methodpayment = []
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/users/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          if (response.statusCode == 200) {
            this.data_campus = [
              { label: "TODOS", value: null },
              ...response.data.map((element) => ({
                label: element.name,
                value: element.id,
              })),
            ];
          }
        }
      });
    },
    getCorrelatice() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/getCorrelative/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.voucherSearch.correlative_serie = response.data[0].serie;
        }
      });
    },
    getData(campuId = null) {
      if (
        !this.filter.init ||
        !this.filter.end ||
        this.filter.init > this.filter.end
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, selecciona un rango de fechas válido.",
        });
      }
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/index",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: campuId,
          company_id: this.$store.getters.get_company.id,
        },
      }).then((response) => {
        this.data_cancel = response.data;
        let index = 1;
        this.data_cancel.forEach((item) => {
          item.campu = item.voucher.campu.name;
          item.serie = item.voucher.serie + "-" + item.voucher.number;
          item.date_format = moment(item.date).format("DD/MM/YYYY");
          item.client_name = item.voucher.voucher_fullname;
          item.personal_name = item.user.name + " " + item.user.last_name;
          item.subtotal = item.voucher.amount;
          item.total = item.voucher.sale.total_payment;
          item.index = index++;
          item.status = this.getStateDisplay(item.state);
          if (item.state == 1 && this.rol_id == 1) {
            item.is_state = true;
          } else {
            item.is_state = false;
          }
        });
      });
    },

    getStateDisplay(state) {
      switch (parseInt(state)) {
        case 1:
          return "En proceso";
        case 2:
          return "Aceptado";
        case 3:
          return "Rechazado";
        default:
          return "Desconocido";
      }
    },

    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      if (action == "store") {
        this.modal.title = "Nuevo(a) Cancelación";
      }

      if (action == "store") {
        this.voucherClient = {
          client: "",
          amount: "",
          serie: "",
          number: "",
        };
        this.voucherSearch.number = "";
        this.voucherCancel = {
          voucher_id: 0,
          user_id: this.$store.getters.get__user_id,
          date: "",
          motive: "",
          state: 0,
          amount: null,
          method: null,
          company_id: this.$store.getters.get_company.id,
          campu_id: this.$store.getters.get_campu.id,
        };
      } else {
        this.voucherClient = { ...this.voucherClient };
      }
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    searchVocuher() {
      if (!this.voucherSearch.number) {
        Swal.fire({
          title: "El número de documento no debe estar vacío",
          icon: "error",
        });
        return;
      }

      this.post({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/searchVocuher",
        token: this.$store.getters.get__token,
        params: this.voucherSearch,
      })
        .then((response) => {
          const data = response.data;

          if (data.state === 0) {
            this.voucherClient.client = "";
            Swal.fire({
              title: "Voucher no encontrado",
              text: "No existe el número de ticket.",
              icon: "warning",
            });
            this.voucherClient.client = "";
            this.voucherCancel.amount = null;
            return;
          }

          if (data.state === 2) {
            this.voucherClient.client = "";
            Swal.fire({
              title: "Voucher cancelado",
              text: "Este voucher ya ha sido cancelado.",
              icon: "info",
            });
            this.voucherCancel.amount = null;
            this.closeModal();
          }

          this.content_voucher = data.voucher || {};
          this.voucherClient.client = data.voucher
            ? data.voucher.voucher_fullname
            : "";
          this.voucherCancel.voucher_id = data.voucher ? data.voucher.id : null;
          this.voucherCancel.amount = data.voucher ? data.voucher.amount : null;
        })
        .catch((error) => {
          Swal.fire({
            title: "Error en la búsqueda",
            text: "Ocurrió un error al buscar el voucher.",
            icon: "error",
          });
          console.error("Error en searchVocuher:", error);
        });
    },

    mtd_action_vali() {
      if (!this.voucherClient.client) {
        Swal.fire({
          title: "No tiene Cliente",
          text: "Debe seleccionar un cliente antes de continuar.",
          icon: "warning",
        });
        return;
      }

      if (!this.voucherCancel.amount) {
        Swal.fire({
          title: "No tiene Monto",
          icon: "warning",
        });
        return;
      }

      if (!this.voucherCancel.method) {
        Swal.fire({
          title: "Debe seleccionar un Metodo",
          icon: "warning",
        });
        return;
      }

      if (!this.voucherCancel.motive.trim()) {
        Swal.fire({
          title: "Debe ingresar un motivo",
          icon: "warning",
        });
        return;
      }
      this.mtd_action();
    },

    mtd_action() {
      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params: this.voucherCancel,
      })
        .then((response) => {
          const state = response.data.state;

          if (state === 1) {
            Swal.fire({
              title: "Cancelación en revisión",
              text: "Tu solicitud de cancelación está siendo revisada.",
              icon: "error",
            });
            this.closeModal();
          } else if (state === 3) {
            Swal.fire({
              title: "Solicitud rechazada",
              text: "Tu solicitud de cancelación fue rechazada.",
              icon: "error",
            });
            this.closeModal();
          } else {
            Swal.fire({
              title: "Solicitud enviada",
              text: "Tu solicitud de cancelación ha sido registrada y está en revisión.",
              icon: "success",
            });
            this.getData();
            this.closeModal();
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Error al registrar",
            text: "Ocurrió un error al procesar la solicitud.",
            icon: "error",
          });
        });
    },

    mtd_ticket(item) {
      if (item?.voucher?.id && item?.voucher?.detail) {
        const voucher = item.voucher.id;
        const document_name = item.voucher.document_type.name;
        if (document_name == "NOTA DE VENTA") {
          window.open(
            this.$store.getters.get__url +
              "/sales/ticket/" +
              voucher +
              "/" +
              this.$store.getters.get__user_id,
            "_blank"
          );
        } else {
          const sunatData = JSON.parse(item.voucher.sunat);
          const ticketUrl = sunatData?.json?.enlace_del_pdf_ticket;
          window.open(ticketUrl, "_blank");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Ticket",
          text: "Está cita todavía no tiene documento",
        });
      }
    },

    mtd_cancel_ticket(item) {
      Swal.fire({
        title: "Cancelación de ticket",
        html: `
                  <div class="text-center">
                      <p><strong>Motivo de cancelación:</strong></p>
                      <p>${item.motive_cancel || "No se especificó motivo"}</p>
                  </div>
              `,
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        denyButtonColor: "#6c757d",
        confirmButtonText: "Aceptar cancelación",
        cancelButtonText: "Rechazar cancelación",
        denyButtonText: "Cerrar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isDenied) {
          return;
        }

        if (result.isConfirmed || result.isDismissed) {
          const params = {
            id: item.id,
            company_id: this.$store.getters.get_company.id,
            campu_id: this.$store.getters.get_campu.id,
            voucher_id: item.voucher.id,
            user_id: this.$store.getters.get__user_id,
            date: moment().format("YYYY-MM-DD"),
            motive: item.motive_cancel,
            state: result.isConfirmed ? 2 : 3,
            products: item.voucher.sale.detail,
          };

          this.post({
            url: `${this.$store.getters.get__url}/${this.prefix}/updateState`,
            token: this.$store.getters.get__token,
            params: params,
          })
            .then((response) => {
              if (response.data.state == 2) {
                Swal.fire({
                  title: result.isConfirmed
                    ? "Cancelación aceptada"
                    : "Cancelación rechazada",
                  text: result.isConfirmed
                    ? "El ticket ha sido cancelado exitosamente."
                    : "La solicitud de cancelación ha sido rechazada.",
                  icon: "success",
                });
                this.getData(this.selectedCampus);
              }
            })
            .catch((error) => {
              Swal.fire({
                title: "Error",
                text: "Ocurrió un error al procesar la solicitud.",
                icon: "error",
              });
              console.error("Error en updateState:", error);
            });
        }
      });
    },

    mtdGetMethods: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/index/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.data_methodpayment = response.data.methodPayment;
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: "Error",
            text: errors,
            icon: "error",
          });
        });
    },
  },
};
</script>
